import { createUseData } from "../../../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./create-user-dialog.service";

export const useUserTypes = createUseData(
    service.getUserTypes,
)